import { createAction } from 'redux-actions';
import { call, takeEvery } from 'redux-saga/effects';
import { requestUrlEvent } from 'modules/fetch/api';

const INSERT_URL_EVT = 'urlEvt/INSERT_URL_EVT';

export const insertUrlEvt = createAction(INSERT_URL_EVT);

export function* insertUrlEvtAction(action) {
  const param = {
    ...action.payload,
  };

  yield call(requestUrlEvent, param);
}

export function* insertUrlEvtSaga() {
  yield takeEvery(INSERT_URL_EVT, insertUrlEvtAction);
}
